import { TextalignRight, NoteText, MessageText, Link21 } from "iconsax-reactjs";
import InputFiel from "../../commons/InputFiel";

type StoriesTextSectionProps = {
  cover: string;
  button: string;
  relatedContent: string;
  description: string;
  onCoverChange: (v: string) => void;
  onButtonChange: (v: string) => void;
  onRelatedContentChange: (v: string) => void;
  onDescriptionChange: (v: string) => void;
}

export default function StoryTextSection({ cover, button, relatedContent, description, onCoverChange, onButtonChange, onRelatedContentChange, onDescriptionChange }: StoriesTextSectionProps) {

  return (
    <div className="max-w-full bg-white border rounded-2xl card-shadow p-4 flex flex-col gap-6">

      <div className="flex flex-col gap-3">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <NoteText size="20" />
          متن کاور
        </h3>
        <InputFiel 
          as="input"
          size="lg"
          value={cover}
          placeholder="مثلا: 8 روز دیگر"
          maxLength={30}
          disabled={false}
          onChange={(e) => onCoverChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 30 کاراکتر میباشد.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <MessageText size="20" />
          متن دکمه
        </h3>
        <InputFiel 
          as="input"
          size="lg"
          value={button}
          placeholder="مثلا: مشاهده جزئیات"
          maxLength={30}
          disabled={false}
          onChange={(e) => onButtonChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 30 کاراکتر میباشد.
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <Link21 size="20" />
          لینک محتوا
        </h3>
        <InputFiel 
          as="input"
          size="lg"
          value={relatedContent}
          placeholder="آدرس بعد از دامین وارد شود"
          maxLength={50}
          disabled={false}
          onChange={(e) => onRelatedContentChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 50 کاراکتر میباشد.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <TextalignRight size="20" />
          توضیح کوتاه
        </h3>
        <InputFiel 
          as="textarea"
          size="lg"
          value={description}
          placeholder="توضیح کوتاه درباره محتوای بنر"
          maxLength={150}
          rows={3}
          disabled={false}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 150 کاراکتر میباشد.
        </p>
      </div>
    </div>
  )
};